import { assign, setup } from 'xstate';

enum EVENTS {
  SELECT = 'SELECT',
}

type MachineContext = {
  value: unknown;
};
type MachineInput = MachineContext | null | undefined;
type MachineOutput = MachineContext;
type MachineEvents = {
  type: EVENTS.SELECT;
  value: unknown;
};

const ACTIONS = {
  SELECT: 'SELECT',
};

const STATES = {
  NOT_SELECTED: 'NOT_SELECTED',
  SELECTED: 'SELECTED',
};

export const machine = setup({
  types: {
    context: {} as MachineContext,
    events: {} as MachineEvents,
    input: {} as MachineInput,
    output: {} as MachineOutput,
  },
  actions: {
    [ACTIONS.SELECT]: assign({
      value: ({ event }) => event.value,
    }),
  },
}).createMachine({
  id: 'selector-machine',
  initial: STATES.NOT_SELECTED,
  context: ({ input }) => ({
    value: undefined,
    ...input,
  }),
  states: {
    [STATES.NOT_SELECTED]: {
      on: {
        [EVENTS.SELECT]: {
          target: STATES.SELECTED,
          actions: ACTIONS.SELECT,
        },
      },
    },
    [STATES.SELECTED]: {
      type: 'final',
    },
  },
  output: ({ context }) => context,
});
